import styled from 'styled-components';
export const UserAlertSection = styled.div`
  width: 70px;
  height: 70px;
  background: #c81919;
  position: absolute;
  right: 24px;
  top: ${props => props.positionY + 'px'};
  cursor: grab;
  z-index: 99999;
  display: grid;
  place-items: center;
  border-radius: 24px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  transition: all 0.2s ease;
  .bell {
    font-size: 25px;
    color: #fff;
    animation: ring 4s 0.7s ease-in-out 3;
    cursor: pointer;
  }

  @keyframes ring {
    0% {
      transform: rotate(0);
    }
    1% {
      transform: rotate(30deg);
    }
    3% {
      transform: rotate(-28deg);
    }
    5% {
      transform: rotate(34deg);
    }
    7% {
      transform: rotate(-32deg);
    }
    9% {
      transform: rotate(30deg);
    }
    11% {
      transform: rotate(-28deg);
    }
    13% {
      transform: rotate(26deg);
    }
    15% {
      transform: rotate(-24deg);
    }
    17% {
      transform: rotate(22deg);
    }
    19% {
      transform: rotate(-20deg);
    }
    21% {
      transform: rotate(18deg);
    }
    23% {
      transform: rotate(-16deg);
    }
    25% {
      transform: rotate(14deg);
    }
    27% {
      transform: rotate(-12deg);
    }
    29% {
      transform: rotate(10deg);
    }
    31% {
      transform: rotate(-8deg);
    }
    33% {
      transform: rotate(6deg);
    }
    35% {
      transform: rotate(-4deg);
    }
    37% {
      transform: rotate(2deg);
    }
    39% {
      transform: rotate(-1deg);
    }
    41% {
      transform: rotate(1deg);
    }

    43% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(0);
    }
  }
`;

export const StorageNotification = styled.div`
  background: #fff;
  width: 475px !important;
  padding-bottom: 15px;
  border-top: 10px solid red;
  position: absolute;
  right: ${props => (props.showNotification ? '12px' : '-120%')};
  z-index: 99998;
  font-family: 'Montserrat', sans-serif;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  transition: all 0.2s ease;
  border-radius: 12px;
  .close-icon {
    display: block;
    margin-left: auto;
    background: transparent;
    border: none;
    font-size: 24px;
    padding-right: 25px;
  }
  p {
    font-size: 12px;
    color: #000;
    font-weight: 600;
    letter-spacing: 1px;
    padding: 0 20px;
    margin: 0;
  }
  .err_desc {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    div {
      p,
      a {
        display: inline;
        font-size: 13px;
        color: #000;
      }
      a {
        font-weight: 700;
      }
    }
  }
  button.ant-btn {
    background: #000 !important;
    border: transparent;
    border-radius: 12px;
    color: #fff;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 700;
  }
  .ant-btn[disabled] {
    color: rgba(0, 0, 0, 0.25) !important;
    background-color: #f5f5f5 !important;
    cursor: not-allowed !important;
  }
  hr {
    width: 150px;
    margin: 20px auto;
  }
`;
